export const MODAL_TYPE = {
  CENTER: "centerModal",
  CENTER_LARGE: "centerModalLarge",
  SIDE_RIGHT: "rightSideModal"
};

export const MODAL_ANIMATION_TIME_MS = 500;
